/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Adjustments_To_ApproveInputs */

const en_queue_adjustments_to_approve = /** @type {(inputs: Queue_Adjustments_To_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock adjustments to approve`)
};

/**
* | output |
* | --- |
* | "Stock adjustments to approve" |
*
* @param {Queue_Adjustments_To_ApproveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_adjustments_to_approve = /** @type {((inputs?: Queue_Adjustments_To_ApproveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Adjustments_To_ApproveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_adjustments_to_approve(inputs)
});